export default "__VITE_ASSET__C9RxoJi$__"